import { Login } from '@mui/icons-material';
import { Alert, AlertTitle } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Link, Navigate, useSearchParams } from 'react-router-dom';

import { apiUrls } from '@/api/apiUrls';
import { Button } from '@/components/Button';
import { routerUrls } from '@/configs/routes/routerUrls';
import { useUserStore } from '@/configs/store';
import { IS_V2_WRITE_ENABLED } from '@/configs/v2Write';
import { markKtsidLogin } from '@/utils/ktsidLoginMark';

import s from './LoginPage.module.scss';

/**
 * Вход через OIDC (KTSID): бэкенд ведёт в провайдер и после входа возвращает на главную,
 * оттуда уводим в новый учёт. Основной вход — токеном Яндекс Трекера, без него нет старого учёта
 */
const LoginPage = observer(() => {
  const [searchParams] = useSearchParams();
  const { isAuthorized } = useUserStore();
  // Ошибку входа бэкенд отдаёт редиректом на /error, роутер превращает его в ?error=
  const hasError = searchParams.has('error');

  const login = () => {
    markKtsidLogin();
    // Тот же адрес, что у API-клиентов: сессионная cookie ставится бэкендом
    window.location.href = `${import.meta.env.VITE_API_URL ?? ''}${apiUrls.auth.startOAuthFlow}`;
  };

  if (isAuthorized) return <Navigate to={routerUrls.v2.table} replace />;

  return (
    <main className={s.login}>
      <div className={s.login__card}>
        <h1 className={s.login__title}>Timelog</h1>
        <p className={s.login__subtitle}>Учёт времени и задачи команды</p>

        {hasError && (
          <Alert severity="error" sx={{ borderRadius: '6px', textAlign: 'left' }}>
            Не удалось войти. Попробуйте ещё раз.
          </Alert>
        )}

        <Button
          startIcon={<Login />}
          onClick={login}
          sx={{ width: '100%', padding: '10px 20px', fontSize: 16 }}
        >
          Войти через KTSID
        </Button>
        <p className={s.login__hint}>Корпоративный аккаунт KTS</p>
        <Alert severity="warning" sx={{ borderRadius: '6px', textAlign: 'left' }}>
          <AlertTitle>Только новый учёт</AlertTitle>
          Через KTSID открывается только новый учёт
          {IS_V2_WRITE_ENABLED ? '' : ' — пока только для просмотра'}. Старый пишет логи в
          Яндекс.Трекер — для него войдите токеном Яндекс Трекера.
        </Alert>
        <Link to={routerUrls.login} className={s.login__link}>
          ← Войти токеном Яндекс Трекера
        </Link>
      </div>
    </main>
  );
});

export default LoginPage;
